const useCreateFile = async (url: string, name: string) => {
  const { origin } = useRequestURL();
  const imageUrl = new URL(url, origin);
  const { body } = await fetchRequest<Blob>(imageUrl.href);

  if (body.type) {
    const fileMetadata = {
      type: body.type,
    };

    return new File([body], name, fileMetadata);
  }
};

const useCreateFilePreview = (file: File) => {
  const { $env } = useNuxtApp();

  if ($env.isClient) {
    return window.URL.createObjectURL(file);
  }
};

export { useCreateFile, useCreateFilePreview };
